module.exports = __webpack_public_path__ + "img/jimny.7dfd1540.svg";